// @ts-nocheck
import React from "react";

export const ErrorBoundary = ({ error }: { error: any }) => (
  <div>{error?.message}</div>
);
